import React from 'react';
import StatusbarConstants from '../../../../../constants/statusbar_constants';
import { EditLabel } from './edit_label';
import { SimpleLabel } from './simple_label';

function getSizeLabelComponent(status) {
    switch (status) {
        case StatusbarConstants.SPEED_INDEX_MISSING:
        /* falls through */
        case StatusbarConstants.LOAD_INDEX_MISSING:
        /* falls through */
        case StatusbarConstants.TYRE_INDEX_MISSING:
        /* falls through */
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
        /* falls through */
        case StatusbarConstants.POSTCODE_MISSING:
        /* falls through */
        case StatusbarConstants.NONE_MISSING:
            return <EditLabel />;

        case StatusbarConstants.ALL_MISSING:
            /* falls through */
        case StatusbarConstants.DIMENSIONS_MISSING:
            /* falls through */
        default:
            return <SimpleLabel />;
    }
}

export { getSizeLabelComponent };